/* rs-gift-guard.js — clears stale gift state from an EMPTY cart, on every page.

   Loaded by sections/cart-popup.liquid (the drawer is on every page). Why: Shopify
   keeps cart.note and cart.attributes when the cart empties (measured 2026-09-28).
   Without this, a cart emptied from the drawer on a PDP or collection page keeps
   its "GIFT MESSAGE: …" note. After a refill, the drawer's express buttons would
   carry the old message onto a different order, unseen, because the /cart panel
   is never visited.

   Free gift wrap was removed (Sam, 2026-10-02). Nothing writes "GIFT WRAP: Yes"
   or the "Gift wrap" attribute any more, but carts saved before then can still
   hold them, so WRAP_LINE and ATTR_KEY stay here as LEGACY markers: still
   recognised and cleared, never written.

   Two triggers:
   1. cartUpdate with cartData.item_count === 0 (drawer remove/stepper, /cart
      native qty, etc.). SUBSCRIBES ONLY — never publishes cartUpdate, which would
      hit cart-popup.js's drawer auto-open subscriber.
   2. Page load with an empty cart already carrying gift state (emptied some
      other way). cart-popup.liquid decides this server-side and sets
      data-stale="true" on this script's tag, so a normal page load costs no
      extra request.

   Clears ONLY what the gift feature owns: the note, if it starts with a gift
   marker (a note without one is left untouched), and the legacy Gift wrap
   attribute.
   Other attribute keys are never sent.

   Wherever a <rs-gift-panel> renders (assets/rs-gift.js), the panel clears its
   own state and resets its fields, so this guard stands down there to keep one
   writer per page. Since Digital #96 (Sam 2026-10-30) the panel is also in the
   cart drawer on every page except /cart, so with the gift panel setting on,
   this guard only acts on an empty /cart page (no panel renders there); with
   the setting off, it acts on every page, as before.

   Markers are shared with rs-gift.js and rs-gift-panel.liquid — see the
   Cross-File Selector Registry in CLAUDE.md before renaming any of them. */
(function () {
  'use strict';

  var MSG_PREFIX = 'GIFT MESSAGE: ';
  var WRAP_LINE = 'GIFT WRAP: Yes'; // legacy (pre-2026-10-02), clear-only
  var ATTR_KEY = 'Gift wrap'; // legacy (pre-2026-10-02), clear-only
  var inFlight = false;
  var tag = document.currentScript;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function hasMarker(note) {
    note = note || '';
    return note.indexOf(MSG_PREFIX) === 0 || note.indexOf(WRAP_LINE) === 0;
  }

  function clearStale(cart) {
    if (!cart || cart.item_count !== 0) return;
    if (document.querySelector('rs-gift-panel')) return;
    var body = {};
    if (hasMarker(cart.note)) body.note = '';
    if (cart.attributes && cart.attributes[ATTR_KEY]) {
      body.attributes = {};
      body.attributes[ATTR_KEY] = '';
    }
    if (!('note' in body) && !body.attributes) return;
    if (inFlight) return;
    inFlight = true;
    fetch(root() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .catch(function (err) { console.warn('rs-gift-guard: clear failed', err); })
      .then(function () {
        inFlight = false;
        // Digital #97: note changed; keep the shared cart read fresh.
        if (window.rsCartEvents) window.rsCartEvents.mutated();
      });
  }

  function fetchAndClear() {
    fetch(root() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(clearStale)
      .catch(function () {});
  }

  function onCartUpdate(evt) {
    var cart = evt && evt.cartData;
    if (!cart || cart.item_count !== 0) return;
    // Every current publisher sends a full cart object; if one ever sends a
    // partial one, read the cart rather than guess.
    if (typeof cart.note === 'undefined' || !cart.attributes) { fetchAndClear(); return; }
    clearStale(cart);
  }

  // Bare identifiers: PUB_SUB_EVENTS is a top-level const (constants.js), never
  // a window property. pubsub.js/constants.js are deferred in <head>, so they
  // have run by the time this deferred body script does.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
  }

  if (tag && tag.dataset.stale === 'true') fetchAndClear();
})();
